module.exports = __webpack_public_path__ + "media/alarm.cc927242.wav";